<template>
    <div class="rating">
        <div
            v-if="ratingError"
            class="alert is-error"
        >
            <div class="w-full flex flex-col">
                <div class="flex">
                    <div class="alert-icon">
                        <font-awesome-icon icon="exclamation-circle" />
                    </div>
                    <div>
                        <span>{{ ratingError }}</span>
                    </div>
                </div>
            </div>

            <div
                class="ml-auto pl-lg mr-0 cursor-pointer"
                @click="setRatingError(null)"
            >
                <font-awesome-icon
                    :icon="['fas', 'times']"
                    class="close"
                />
            </div>
        </div>

        <div>
            <div class="flex flex-col md:flex-row md:items-center md:pr-lg">
                <div v-if="product.average_rating" class="flex items-center text-xs leading-none md:mr-lg">
                    <font-awesome-icon icon="star" class="self-stretch mr-sm text-green-500" />
                    <span class="font-bold">
                        {{ formatNumber(product.average_rating) }}
                        ({{ product.rating_count }} st)
                    </span>
                    <button
                        type="button"
                        class="ml-auto text-xxs underline hover:text-green-500 md:ml-md"
                        @click="toggled = ! toggled"
                    >
                        <span v-if="toggled">
                            Dölj detaljer
                        </span>
                        <span v-else>
                            Visa detaljer
                        </span>
                    </button>
                </div>
                <div v-else class="text-xs">
                    Bli den första att tycka till!
                </div>

                <div class="md:flex md:items-center general-rating flex-none mt-2xl md:mt-0 md:ml-auto">
                    <rate-stars
                        rating-type="general"
                        :existing-rating="existingRating"
                        :product="product"
                        :user-has-rated="userHasRated"
                        :user-diet="userDiet"
                        @product-and-rating-updated="updateProductAndRating"
                        @rating-error="setRatingError"
                    />
                </div>
            </div>
            <div
                v-if="toggled"
                class="mt-lg text-xxs"
            >
                <ul class="mb-0 border-l border-pink-500 leading-relaxed">
                    <li class="pl-lg font-semibold">Kostbaserat genomsnitt</li>
                    <li class="pl-lg flex justify-between md:justify-start md:items-center">
                        {{ dietLabels.meat }}:
                        <span class="ml-sm text-xs">{{ formatNumber(product.additional_data.rating_type_averages.general.meat) }}</span>
                    </li>
                    <li class="pl-lg flex justify-between md:justify-start md:items-center">
                        {{ dietLabels.plants }}:
                        <span class="ml-sm text-xs">{{ formatNumber(product.additional_data.rating_type_averages.general.plants) }}</span>
                    </li>
                    <li class="pl-lg flex justify-between md:justify-start md:items-center">
                        Okänd kost:
                        <span class="ml-sm text-xs">{{ formatNumber(product.additional_data.rating_type_averages.general.unknown) }}</span>
                    </li>
                </ul>
            </div>
        </div>

        <div class="bg-gray-100 rounded mt-2xl px-lg">
            <sub-rating
                v-for="(ratingLabel, ratingType) in subRatingTypes"
                :key="ratingType"
                :product="product"
                :existing-rating="existingRating"
                :rating-type="ratingType"
                :rating-label="ratingLabel"
                :user-has-rated="userHasRated"
                :user-diet="userDiet"
                @product-and-rating-updated="updateProductAndRating"
                @rating-error="setRatingError"
            />
        </div>
    </div>
</template>

<script>
    import RateStars from './RateStars';
    import SubRating from './SubRating';

    export default {
        components: {
            RateStars,
            SubRating,
        },
        props: {
            initialProduct: {
                type: Object,
                required: true,
            },
            initialRating: {
                type: Object,
                default: null,
            },
            subRatingTypes: {
                type: Object,
                required: true,
            },
            userHasRated: {
                type: Boolean,
                required: true,
            },
            userDiet: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                product: this.initialProduct,
                existingRating: this.initialRating,
                toggled: false,
                ratingError: null,
                dietLabels: window.App.dietLabels,
            };
        },

        methods: {
            updateProductAndRating(product, rating) {
                this.product = product;
                this.existingRating = rating;
            },
            setRatingError(error) {
                this.ratingError = error;
            },
        },
    };
</script>
